import * as React from "react";
import { useCallback } from "react";
import ViewLoaderContext from "views/logic/ViewLoaderContext";
import NewViewLoaderContext from "views/logic/NewViewLoaderContext";
import Search from "views/components/Search";
import { loadNewView as defaultLoadNewView, loadView as defaultLoadView } from "views/logic/views/Actions";
import IfUserHasAccessToAnyStream from "views/components/IfUserHasAccessToAnyStream";
import DashboardPageContextProvider from "views/components/contexts/DashboardPageContextProvider";
import { DocumentTitle, Spinner } from "components/common";
import useProcessHooksForView from "views/logic/views/UseProcessHooksForView";
import useQuery from "routing/useQuery";
import ViewsStoreProvider from "views/stores/ViewsStoreProvider";
import useViewTitle from "views/hooks/useViewTitle";
import SearchExecutionState from "views/logic/search/SearchExecutionState";
import useHistory from "routing/useHistory";
import SearchPageAutoRefreshProvider from "views/components/contexts/SearchPageAutoRefreshProvider";
import IlluminateDashboardViewTelemetry from "views/components/IlluminateDashboardViewTelemetry";
const SearchPageTitle = ({ children }) => {
  const title = useViewTitle();
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title }, children);
};
const SearchPage = ({
  children = void 0,
  isNew,
  view: viewPromise,
  loadNewView: _loadNewView = defaultLoadNewView,
  loadView: _loadView = defaultLoadView,
  executionState: initialExecutionState = SearchExecutionState.empty(),
  searchResult = void 0,
  forceSideBarPinned = false,
  skipNoStreamsCheck = false,
  loadingPlaceholder = /* @__PURE__ */ React.createElement(Spinner, null)
}) => {
  const query = useQuery();
  const initialQuery = query == null ? void 0 : query.page;
  const history = useHistory();
  const loadNewView = useCallback(() => _loadNewView(history), [_loadNewView, history]);
  const loadView = useCallback((viewId) => _loadView(history, viewId), [_loadView, history]);
  const result = useProcessHooksForView(viewPromise, initialExecutionState, query);
  if (result.status === "loading") {
    return loadingPlaceholder;
  }
  if (result.status === "interrupted") {
    return result.component;
  }
  const { view, executionState } = result;
  return view ? /* @__PURE__ */ React.createElement(
    ViewsStoreProvider,
    {
      view,
      executionState,
      isNew,
      initialQuery,
      result: searchResult
    },
    /* @__PURE__ */ React.createElement(IlluminateDashboardViewTelemetry, null),
    /* @__PURE__ */ React.createElement(SearchPageTitle, null, /* @__PURE__ */ React.createElement(DashboardPageContextProvider, null, /* @__PURE__ */ React.createElement(NewViewLoaderContext.Provider, { value: loadNewView }, /* @__PURE__ */ React.createElement(ViewLoaderContext.Provider, { value: loadView }, /* @__PURE__ */ React.createElement(SearchPageAutoRefreshProvider, null, children, /* @__PURE__ */ React.createElement(IfUserHasAccessToAnyStream, { skipNoStreamsCheck }, /* @__PURE__ */ React.createElement(Search, { forceSideBarPinned, loadingPlaceholder })))))))
  ) : loadingPlaceholder;
};
export default React.memo(SearchPage);
